import React from 'react';
import { useNavigate } from 'react-router';
import { ChevronLeft } from 'lucide-react';
import { cn } from '../utils/cn';
import './TitleWithCrumb.css';

/**
 * Page title that absorbs the breadcrumb instead of repeating it: when a
 * return path is present, "<parent> / <title>" renders as one line at a
 * single size and weight, with only text color separating the parent link
 * from the active page. Hovering/focusing the parent link reveals a back
 * chevron. Falls back to a plain title when there's no return path.
 *
 * Ported from the reporting UI. There, the return path comes from a
 * useReturnBreadcrumb hook tied to that app's deep-linking; this admin UI has
 * flat routes and no such concept, so the crumb is passed in explicitly and
 * simply doesn't render when it's absent.
 */
export default function TitleWithCrumb({ title, returnTo, returnLabel, className }) {
  const navigate = useNavigate();
  const hasCrumb = !!returnTo && !!returnLabel;

  return (
    <div className={cn('twc', className)}>
      {hasCrumb ? (
        <>
          <button type="button" onClick={() => navigate(returnTo)} className="twc-parent">
            <span className="twc-chevron-slot">
              <ChevronLeft className="twc-chevron" />
            </span>
            {returnLabel}
          </button>
          <span className="twc-separator">/</span>
        </>
      ) : null}
      <h1 className="twc-title">{title}</h1>
    </div>
  );
}
